import { createApi } from '@reduxjs/toolkit/query/react'

import { getCustomFetch } from '@/shared/api/custom-fetch-base'
import { IProfile, IProfilePermissions } from '@/shared/types/user'

import { IProfilePasswordUpdate, IProfileUpdate } from '../model/types'

const organizations = [
  {
    organizationId: 10,
    // organizationLabel: 'Моя организация',
    roleId: 1,
    // role: {
    //   id: 1,
    //   name: 'admin',
    //   label: 'Администратор',
    // },
  },
]

const permissions: IProfilePermissions = {
  global: ['knowledge', 'create-organization'],
  organizations: {
    // '4964a76a-7442-471f-8459-91d1d45abfff': [
    //   'view-organization',
    //   'update-organization',
    //   'remove-organization',
    //   'create-office',
    //   'view-user',
    //   'create-user',
    //   'update-user',
    //   'remove-user',
    //   'view-role',
    //   'create-role',
    //   'update-role',
    //   'remove-role',
    // ],
  },
  offices: {
    15: ['view-office', 'update-office'],
    16: ['view-office', 'update-office', 'remove-office'],
    17: ['view-office', 'remove-office'],
  },
}

export const profileApi = createApi({
  reducerPath: 'profileApi',
  baseQuery: getCustomFetch(),
  tagTypes: ['profile'],
  endpoints: build => ({
    profile: build.query<IProfile, void>({
      query: () => ({
        url: '/user/profile/',
        method: 'GET',
      }),
      providesTags: ['profile'],
      transformResponse: (response: IProfile) => ({
        ...response,
        status_email: response.status_email ?? 'none',
        status_phone: response.status_phone ?? 'none',
      }),
    }),

    updateProfile: build.mutation<IProfile, IProfileUpdate>({
      query: body => ({ url: `user/profile/`, method: 'PATCH', body }),
      invalidatesTags: ['profile'],
    }),

    updateProfilePassword: build.mutation<void, IProfilePasswordUpdate>({
      query: body => ({ url: `user/profile/password`, method: 'PATCH', body }),
      invalidatesTags: ['profile'],
    }),

    deleteProfile: build.mutation<void, void>({
      query: () => ({ url: `user/profile/`, method: 'DELETE' }),
      invalidatesTags: ['profile'],
    }),
  }),
})

export const {
  useProfileQuery,
  useUpdateProfileMutation,
  useUpdateProfilePasswordMutation,
  useDeleteProfileMutation,
} = profileApi
